import {CTBComponentPage as BaseCTBComponentPage} from './Component'
import {loader} from "./loader"
const CTBComponentPage = Object.assign(BaseCTBComponentPage, {loader})
export {CTBComponentPage}
